module.exports = __webpack_public_path__ + "media/images/img-hobby-7-226e01dc.jpg";